import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import '../styles/Stats.css';

function Stats() {
  const { ref, inView } = useInView({
    threshold: 0.3,
  });

  const [visible, setVisible] = useState(false);

  // Track when inView toggles to re-trigger animation and CountUp
  useEffect(() => {
    if (inView) {
      setVisible(true);
      setTimeout(() => setVisible(false), 1000); // Reset for retrigger
    }
  }, [inView]);

  const stats = [
    { label: 'Employees', value: 50 },
    { label: 'Students', value: 1000 },
    { label: 'Trainees', value: 30 },
    { label: 'Trades', value: 8 },
    { label: 'Centers', value: 2 },
  ];

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div
            className={`stat-box ${inView ? 'come-up' : ''}`}
            key={index}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <h3>
              {inView && (
                <CountUp
                  end={stat.value}
                  duration={2.5}
                  key={visible ? `count-${index}-${Date.now()}` : `idle-${index}`}
                />
              )}
              +
            </h3>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
